import { Component, computed, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideLoaderCircle } from '@ng-icons/lucide';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Component({
  selector: 'app-spinner',
  imports: [HlmIconImports, HlmSpinnerImports],
  host: {
    '[class]': '_computedClass()',
    role: 'status',
  },
  template: ` <hlm-spinner class="text-white" icon="lucideLoaderCircle" size="xl" /> `,
  providers: [provideIcons({ lucideLoaderCircle })],
})
export class SpinnerComponent {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    hlm(
      'bg-transparency z-1 absolute -m-lg flex h-full w-full items-center justify-center opacity-70',
      this.userClass(),
    ),
  );
}
